module.exports = __webpack_public_path__ + "static/media/infografia_galdisa_embarazo_es.a5523f86.jpg";